import { useUserPreferences } from '@pm2/api';
import { avoidBreakInside } from '@provider/print';
import { units } from '@ui/css';
import { fonts, fontScales } from '@ui/kit/design-tokens';
import { CrossIcon, RoundedCheckmarkIcon, PencilIcon } from '@ui/kit/icons';
import { useStringLength } from '@utils/react';
import { useOpgavekompleksetComponent } from '../../../../state/context.data.js';
import { tokens, wrapper, input, pencil, icon } from './atom.text-input.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function TextInput(props) {
  const component = useOpgavekompleksetComponent();
  const preferences = useUserPreferences();
  const {
    fontSize = 18
  } = props;
  const font = preferences.font === "default" ? fonts.proxima : fonts.dyslexie;
  const valueLengthInPx = useStringLength(props.value ?? "", {
    size: fontSize * (preferences.font === "dyslexie" ? fontScales.dyslexie : fontScales.proxima),
    family: String(font.fontFaces.bold.family.defaultValue),
    weight: String(font.fontFaces.bold.weight.defaultValue)
  });
  const minLengthInPx = useStringLength("0".repeat(props.minimumInputLength ?? 0), {
    size: fontSize * (preferences.font === "dyslexie" ? fontScales.dyslexie : fontScales.proxima),
    family: String(font.fontFaces.bold.family.defaultValue),
    weight: String(font.fontFaces.bold.weight.defaultValue)
  });
  const icon$1 = (() => {
    switch (props.state) {
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {});
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1.5,
          height: 10
        });
    }
  })();
  return /*#__PURE__*/jsxs("span", {
    className: wrapper,
    style: tokens.__override({
      width: props.widthStrategy === "fixed" ? units.px(minLengthInPx) : units.px(Math.max(minLengthInPx, valueLengthInPx)),
      fontSize: units.px(fontSize)
    }),
    "data-state": props.state,
    "data-height": props.height,
    "data-alignment": props.alignment,
    "data-audience": component.data.settings.standalone.audience,
    "data-theme": props.theme,
    ...avoidBreakInside(),
    children: [/*#__PURE__*/jsx("input", {
      className: input,
      type: "text",
      readOnly: props.readOnly,
      spellCheck: false,
      autoCapitalize: "none",
      autoComplete: "off",
      autoCorrect: "off",
      enterKeyHint: props.enterKeyHint,
      value: props.value ?? "",
      onChange: props.onChange,
      inputMode: props.inputMode,
      pattern: props.inputMode === "numeric" ? "[0-9]*" : undefined
    }), props.state === "input" && /*#__PURE__*/jsx(PencilIcon, {
      className: pencil
    }), icon$1 && /*#__PURE__*/jsx("span", {
      className: icon,
      children: icon$1
    })]
  });
}

export { TextInput };
//# sourceMappingURL=atom.text-input.js.map
